import React, { Fragment, useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  IconButton,
  TextField,
  Link,
  Typography
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Alert } from '@material-ui/lab'

import { Facebook as FacebookIcon, Google as GoogleIcon } from '../../icons';
import logInWithEmail from '../../actions/logInWithEmail'
import logInWithFacebook from '../../actions/logInWithFacebook'
import logInWithGoogle from '../../actions/logInWithGoogle'

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  suggestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  }
}));

const SignIn = props => {
  const { history } = props;

  const classes = useStyles();

  let email = ''
  // Some browsers don't support this?
  if (typeof URLSearchParams !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    if (params && typeof params.get !== 'undefined') {
      email = params.get('email')
    }
  }
  
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      email: email,
    },
    touched: {},
    errors: {}
  });

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleBack = () => {
    history.goBack();
  };

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSignInWithFacebook = async event => {
    event.preventDefault();
    try {
      await logInWithFacebook()
    }
    catch (e) {
      console.error('Facebook login failed', e)
      alert(e.message)
    }
  };

  const handleSignInWithGoogle = async event => {
    event.preventDefault();
    try {
      await logInWithGoogle()
      if (history) {
        history.push('/')
      }
    }
    catch (e) {
      console.error('Google lgin failed', e)
      alert(e.message)
    }
  };

  const handleSignInWithEmail = async event => {
    event.preventDefault();
    try {

      setLoading(true)
      await logInWithEmail(formState.values.email, formState.values.password)()
    }
    catch (e) {
      console.error('Login failed', e)
      alert(e.message)
    }

    setLoading(false)
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
        justify='center'
        alignItems='center'
      >
        <Grid
          className={classes.content}
          item
          xl={10}
          lg={10}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignInWithEmail}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Sign in
                </Typography>

                { false &&
                  <Fragment>
                    <Typography
                      color="textSecondary"
                      gutterBottom
                    >
                      Sign in with social media
                    </Typography>
                    <Grid
                      className={classes.socialButtons}
                      container
                      spacing={2}
                      justify='center'
                    >
                      { false /* FB not enabled yet */ &&
                        <Grid item>
                          <Button
                            color="primary"
                            onClick={handleSignInWithFacebook}
                            size="large"
                            variant="contained"
                          >
                            <FacebookIcon className={classes.socialIcon} />
                            Login with Facebook
                          </Button>
                        </Grid>
                      }
                      <Grid item>
                        <Button
                          onClick={handleSignInWithGoogle}
                          size="large"
                          variant="contained"
                        >
                          <GoogleIcon className={classes.socialIcon} />
                          Login with Google
                        </Button>
                      </Grid>
                    </Grid>
                    <Typography
                      align="center"
                      className={classes.suggestion}
                      color="textSecondary"
                      variant="body1"
                    >
                      or login with email address
                    </Typography>
                  </Fragment>
                }
                <TextField
                  className={classes.textField}
                  error={hasError('email')}
                  fullWidth
                  helperText={
                    hasError('email') ? formState.errors.email[0] : null
                  }
                  label="Email address"
                  name="email"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.email || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('password')}
                  fullWidth
                  helperText={
                    hasError('password') ? formState.errors.password[0] : null
                  }
                  label="Password"
                  name="password"
                  onChange={handleChange}
                  type="password"
                  value={formState.values.password || ''}
                  variant="outlined"
                />
                <Button
                  className={classes.signInButton}
                  color="primary"
                  disabled={!formState.isValid || loading}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Sign in now
                </Button>
                <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Don't have an account?{' '}
                  <Link
                    component={RouterLink}
                    to={`/register?email=${formState.values.email || ''}`}
                    variant="h6"
                  >
                    Sign up
                  </Link>
                </Typography>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignIn);
